import { Controller } from 'stimulus';
import loadSlick from '../helpers/loadSlick';

class Slider extends Controller {
  connect() {
    loadSlick().then(() => {
      this.$element = $(this.element);

      this.$element.slick({
        prevArrow: Slider.getSliderButton('Vorige', 'slider__arrow slick-prev', 'arrow-left'),
        nextArrow: Slider.getSliderButton('Volgende', 'slider__arrow slick-next', 'arrow-right'),
        ...this.sliderOptionsFromElement(),
      });
    });
  }

  sliderOptionsFromElement() {
    const options = this.$element.data();
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    Object.keys(options).forEach((option) => {
      const regex = new RegExp('^slider', 'g');

      if (!regex.test(option)) {
        return;
      }

      // Transform the key from 'sliderArrows' to 'Arrows'
      let transformedOption = option.replace('slider', '');

      // Lowercase the first character ('Arrows' => 'arrows')
      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      config[transformedOption] = options[option];
    });

    return config;
  }

  static getSliderButton(text, className, icon) {
    return `
      <button type="button" class="${className}">
        <span class="sr-only">${text}</span>
        ${Slider.getButtonIcon(icon)}
      </button>
    `;
  }

  static getButtonIcon(name) {
    return `<i class='icon icon-${name}' aria-hidden="true"></i>`;
  }
}

Slider.targets = [
  //
];

export default Slider;
